import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import ReactDOM from 'react-dom';
import moment from "moment";
import toast from "react-hot-toast";
import { FaCheck } from "react-icons/fa6";

import CustomRecCard from "../../../common/CustomRecCard";
import CustomActionButton from '../../../common/CustomActionButton';
import CustomButton from "../../../common/CustomButton";
import SendSuccess from "../SubComponents/SendSuccess";

import { Check } from '../../../common/CustomIcons';
import { delay, parseJSON, removeDuplicates } from "../../../utils";
import { AddNewCustomEmailTemplate, SaveEmailTemplate, SendEmail } from "../../../redux/v2/patient-invite/actions";
import { SetModalProperties } from "../../../redux/v2/utils/actions";
import CustomInput from "../../../common/CustomInput";

function PatientDetailV2(props) {
    const navigate = useNavigate();
    const { account } = props.User;
    const { pd, emailTemplates, customEmailTemplates, indiPrograms, suggestedPrograms = [] } = props;
    const [email, setEmail] = useState(null);
    const [emailTemplate, setEmailTemplate] = useState(null);
    const [emailTemplateReminder, setEmailTemplateReminder] = useState(null);
    const [generatedEmails, setGeneratedEmails] = useState([]);
    const [htmlPreview, setHtmlPreview] = useState("");
    const [suggestedProgramsEditable, setSuggestedProgramsEditable] = useState([]);
    const [selectedPrograms, setSelectedPrograms] = useState([]);
    const [showAllPrograms, setShowAllPrograms] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [updatedInnerHTML, setUpdatedInnerHTML] = useState("");
    const [eventID, setEventID] = useState("");
    const [patienName, setPatientName] = useState({});
    const linkRegEx = /\b(?:https?:\/\/|www\.)[^\s/$.?#].[^\s]*\b/;


    useEffect(() => {
        let temp = [], temp2 = [];
        for (let x = 0; x < suggestedPrograms?.length; x++) {
            temp.push({
                ...suggestedPrograms[x],
                selected: (x == 0 || x == 1),
            })

            if ((x == 0 || x == 1)) {
                temp2.push(suggestedPrograms[x]);
            }
        }

        setSuggestedProgramsEditable(temp);
        setSelectedPrograms(temp2);
    }, [suggestedPrograms]);

    useEffect(() => {
        if ((patienName?.first_name && patienName?.last_name) && emailTemplate && selectedPrograms?.length > 0) {
            handlePreviewEmail(emailTemplate);
        }
    }, [patienName?.first_name, patienName?.last_name, emailTemplate, selectedPrograms]);

    useEffect(() => {
        setPatientName({
            first_name: pd?.first_name,
            last_name: pd?.last_name,
        });
    }, [pd?.id]);


    useEffect(() => {

        // const sList = [...customEmailTemplates, ...emailTemplates?.filter(et => et?.is_default == 1)]?.sort((a, b) => b.id - a.id);
        const sList = [...emailTemplates?.filter(et => et?.is_default == 1)]?.sort((a, b) => b.id - a.id);

        if (sList?.length > 0) {
            const defaultET = sList?.[0]
            const defaultETReminder = sList?.[0]
            setEmailTemplate(defaultET || null);
            setEmailTemplateReminder(defaultETReminder || null);
        }

    }, [emailTemplates?.length, customEmailTemplates?.length]);

    useEffect(() => {
        if (pd?.generatedEmails.length > 0) {
            let emails = pd?.generatedEmails;
            emails = emails.reverse();
            emails = removeDuplicates(emails, "id");
            setGeneratedEmails(emails);
            setEmail(emails?.[0]);
        }

    }, [pd?.id, pd?.generatedEmails?.length]);

    const arrangeHTMLContent = (htmlTemplate, patient, generatedEmail, eventID = 0, sp) => {
        let htmlContent = htmlTemplate;
        const emailContent = parseJSON(email?.email_content);
        const link = (process.env.REACT_APP_ENVIRONMENT === "PROD" ? process.env.REACT_APP_BASE_API_URL : process.env.REACT_APP_BASE_API_URL_DEV);

        htmlContent = htmlContent.replaceAll("{{patient_name}}", (patienName?.first_name));
        htmlContent = htmlContent.replaceAll("{{patient_email}}", (patient?.email || null));
        htmlContent = htmlContent.replaceAll("{{therapist_name}}", (patient?.therapist_name || null));
        htmlContent = htmlContent.replace("{{email_preview_text}}", emailContent?.email_preview_text);
        htmlContent = htmlContent.replace("{{headline_1}}", emailContent?.headline_1);
        htmlContent = htmlContent.replace("{{subtext_1}}", emailContent?.subtext_1);
        htmlContent = htmlContent.replace("{{headline_2}}", emailContent?.headline_2);
        htmlContent = htmlContent.replace("{{subtext_2}}", emailContent?.subtext_2);
        htmlContent = htmlContent.replace("{{headline_3}}", emailContent?.headline_3);
        htmlContent = htmlContent.replace("{{therapist_email}}", account?.user?.email_address);
        htmlContent = htmlContent.replace("{{therapist_sigline}}", account?.user?.therapist_sigline);

        let svg = null, gradient = null, src = null;
        for (let i = 0; i < selectedPrograms?.length; i++) {
            htmlContent = htmlContent.replace(`{{program_name${i + 1}}}`, `${selectedPrograms[i]?.title}${selectedPrograms[i]?.level ? (" - " + selectedPrograms[i]?.level?.toLowerCase()) : ""}`);
            htmlContent = htmlContent.replace(`{{program_description${i + 1}}}`, selectedPrograms[i]?.info2);
            gradient = selectedPrograms[i]?.gradient?.split("-")
            svg = <div className="program-img-wrapper" style={{ backgroundImage: `linear-gradient(to right, ${gradient?.[0]}, ${gradient?.[1]})`, borderRadius: "50%", padding: "12px" }}>
                <img src={`${link}images/program-icons/${selectedPrograms[i]?.svg?.split(".")[0]}.png`} alt="" />
            </div>
            if (htmlContent?.includes("program_image_src_")) {
                htmlContent = htmlContent.replace(`{{program_image_src_${i + 1}}}`, `${link}images/program-icons/${selectedPrograms[i]?.svg?.split(".")[0]}.png`);
            } else {
                htmlContent = htmlContent.replace(`{{program_image_${i + 1}}}`, extractHTML(svg));
            }
        }

        htmlContent = htmlContent.replace("{{subtext_3}}", emailContent?.subtext_3);
        htmlContent = htmlContent.replace("{{sign_off}}", emailContent?.sign_off);
        htmlContent = htmlContent.replaceAll("{{signup_link}}", `${"https://indimoves.com/brg/"}?type=brgpatient&id=${generatedEmail?.id}&event_id=${eventID}&env=${process.env.REACT_APP_ENVIRONMENT}`);
        htmlContent = htmlContent.replace("{{signup_link2}}", `${"https://indimoves.com/brg/"}?type=brgpatient&id=${generatedEmail?.id}&event_id=${eventID}&env=${process.env.REACT_APP_ENVIRONMENT}`);

        htmlContent = htmlContent.replace("{{time_sent}}", moment().format("MMMM Do YYYY, h:mm:ss a"));

        return htmlContent;
    }

    const handlePreviewEmail = async (et = null) => {
        const tempEventID = new Date().getTime();
        setEventID(eID => tempEventID);
        setHtmlPreview(arrangeHTMLContent(et?.html_content, pd, email, tempEventID, suggestedPrograms));
    }

    const extractHTML = (reactElement) => {
        // Create a temporary container
        const container = document.createElement('div');

        // Render the React element into the container
        ReactDOM.render(reactElement, container);

        // Extract the inner HTML of the container
        const htmlString = container.innerHTML;

        // Cleanup: unmount the component and remove the container
        ReactDOM.unmountComponentAtNode(container);
        container.remove();

        return htmlString;
    }

    const updateSelectedPrograms = (index) => {

        if (selectedPrograms?.length >= max && !suggestedProgramsEditable[index].selected) {
            toast("Only select two programs");
            return;
        } else {

            const temp = [...suggestedProgramsEditable];

            temp[index].selected = !temp[index].selected;

            let temp2 = [...selectedPrograms];
            if (temp[index].selected) {
                temp2.unshift(temp[index]);
                if (temp2.length > 2) {
                    temp2.pop();
                }
            } else {
                temp2 = temp2.filter((sp) => sp?.id != temp[index]?.id);
            }

            // if (temp[index].selected) {
            //     const [toggledItem] = temp.splice(index, 1);
            //     temp.unshift(toggledItem);
            // }

            // let selectedCount = 0;
            // for (let i = 0; i < temp.length; i++) {
            //     if (temp[i].selected) {
            //         selectedCount++;
            //         if (selectedCount > 2) {
            //             temp[i].selected = false;
            //         }
            //     }
            // }

            // temp.sort((a, b) => b.selected - a.selected);

            setSelectedPrograms(temp2);
            setSuggestedProgramsEditable(temp);
        }

    }

    const updateETDom = (prevHtmlContent, updatedInnerHtml) => {
        // Parse the string into a DOM document
        const parser = new DOMParser();
        const doc = parser.parseFromString(prevHtmlContent, 'text/html');
        const targetDiv = doc.getElementById('email-template-editable');

        if (targetDiv) {
            // Update the innerHTML of the editable-content div
            targetDiv.innerHTML = updatedInnerHtml;
            const el2 = doc.getElementsByClassName("ete-uneditable");

            for (let i = 0; i < el2?.length; i++) {
                el2[i].setAttribute('contenteditable', 'false');
                el2[i].classList.remove("ete-uneditable-show");
            }

            // Serialize the updated DOM back to a string
            return "<!doctype html>" + doc.lastElementChild?.outerHTML;
        }

        return prevHtmlContent; // If no editable-content div, return unchanged
    }

    const arrangeEditEmail = () => {
        setIsEdit(!isEdit);

        setUpdatedInnerHTML(emailTemplate?.html_content);

        delay(() => {


            const el = document.getElementById("email-template-editable")
            el?.setAttribute('contenteditable', 'true');
            el?.focus();

            el.addEventListener("input", (event) => {
                setUpdatedInnerHTML(updateETDom(emailTemplate?.html_content, event?.target?.innerHTML));
            });

            el.addEventListener("beforeinput", (event) => {
                const selection = window.getSelection();
                const range = selection.rangeCount > 0 ? selection.getRangeAt(0) : null;
                const sstr = selection.toString();

                const reject = () => {
                    event.preventDefault();
                    toast('This content is protected and cannot be edited or deleted.', {
                        id: 'reject-edit-toast',
                    });
                }


                if (sstr?.includes?.("{{") || sstr?.includes?.("}}") || linkRegEx?.test(sstr)) {
                    reject();
                }

                if (range) {
                    const startContainer = range.startContainer;

                    if (event.inputType.startsWith("delete")) {


                        let deletedContent = "";

                        if (event.inputType === "deleteContentBackward") {
                            // Check the previous sibling or parent content
                            const previousNode = range.startContainer.previousSibling;
                            deletedContent = previousNode ? previousNode.textContent || previousNode.nodeValue : "";
                        } else if (event.inputType === "deleteContentForward") {
                            // Check the next sibling or parent content
                            const nextNode = range.startContainer.nextSibling;
                            deletedContent = nextNode ? nextNode.textContent || nextNode.nodeValue : "";
                        }


                        if (range.startContainer?.nodeName != "#text" || (deletedContent?.includes("{{") || deletedContent?.includes("}}")) || linkRegEx?.test(deletedContent)) {
                            reject();
                        }

                    }
                }
            });

            const el2 = document.getElementsByClassName("ete-uneditable");

            for (let i = 0; i < el2?.length; i++) {
                el2[i].setAttribute('contenteditable', 'false');
                el2[i].classList.add("ete-uneditable-show");
            }

        }, 10);
    }

    const saveEditedEmail = async () => {

        const newCustomEmail = {
            ...emailTemplate,
            html_content: updatedInnerHTML
        }

        const el2 = document.getElementsByClassName("ete-uneditable");
        for (let i = 0; i < el2?.length; i++) {
            el2[i].setAttribute('contenteditable', 'false');
            el2[i].classList.remove("ete-uneditable-show");
        }

        let res;
        if (emailTemplate?.tag == "custom-email" && emailTemplate?.owner != null) {
            res = await props?.SaveEmailTemplate(newCustomEmail);
            setEmailTemplate({ ...newCustomEmail, updated_at: new Date().toISOString() });
        } else {
            res = await props?.AddNewCustomEmailTemplate(newCustomEmail);
            setEmailTemplate(res?.newET);
        }

        setUpdatedInnerHTML("");
        setIsEdit(!isEdit);


        return res?.success || res;

    }

    const revertEditedEmail = () => {
        setEmailTemplate({
            ...emailTemplate,
            html_content: emailTemplate?.html_content + " "
        });
        setIsEdit(!isEdit);
    }

    const showSuccessModal = () => {
        props.SetModalProperties({
            id: "success-page-promo-modal",
            isShow: true,
            title: "",
            height: "100%",
            body: <>
                <SendSuccess close={() => {
                    props.SetModalProperties({
                        isShow: false,
                        title: "",
                        height: "0%",
                        body: <>
                        </>,
                        actions: [],
                        showCloseButton: false,
                    });
                    // navigate("/");
                }} />
            </>,
            actions: [],
            showCloseButton: false,
        });
    }

    const handleSendEmail = async (et) => {
        const toastID = toast.loading("Sending Email...");
        const sender = `${account?.user?.first_name} ${account?.user?.last_name} <${account?.user?.email_address}>`
        let subject = et?.email_subject;
        subject = subject.replace("{{patient_name}}", patienName?.first_name);


        //     pd, emailTemplate, htmlPreview, subject, tempEventID, et
        // });

        const res = await props.SendEmail(pd, emailTemplate, htmlPreview, subject, eventID, et, sender);
        if (res) {

            delay(() => {
                toast.dismiss(toastID);
                showSuccessModal();
            }, 1000);
            // toast.success("Email Sent Successfully", {
            //     id: toastID,
            // });
        } else {
            toast.error("Failed to Send Email", {
                id: toastID,
            });
        }

        return res;

    }

    const handleChangeName = (e) => {
        const split = e?.target?.value?.split(" ");
        setPatientName({
            first_name: split?.[0],
            last_name: split?.[1],
        });
    }

    const spTemp = suggestedProgramsEditable?.filter((sp) => sp?.selected)
    const filteredSPE = showAllPrograms ? suggestedProgramsEditable : spTemp;
    const max = 2;


    return (
        <div id="pi-c-patient-detail">


            <div id="pi-c-pd-email-content">
                <div id="pi-c-pd-ec-to">
                    <h5>TO: </h5>
                    <h5>
                        <CustomInput type="text" value={`${patienName?.first_name} ${patienName?.last_name}`} onChange={handleChangeName} />
                    </h5>

                    {/* <div id="pi-c-pd-actions"> */}
                    <CustomActionButton disabled={isEdit || spTemp?.length < max} type={2} className="active" size="small" action={() => {
                        return handleSendEmail(emailTemplate);
                    }}>Send</CustomActionButton>
                    {/* </div> */}
                </div>

                <div>
                    <h5>FROM: </h5>
                    <h5>{`${account?.user?.first_name} ${account?.user?.last_name}`}</h5>
                </div>

                <div>
                    <h5>SUBJECT: </h5>
                    <h5>Post-Therapy Next Step</h5>
                </div>

                <div id="pi-c-pd-ec-program-selection">
                    <div>
                        <h5>PROGRAMS: </h5>
                        <h5 style={{ marginTop: "30px" }}>Select 2 programs</h5>
                    </div>
                    <div id="pi-c-pd-suggested-programs">

                        {
                            filteredSPE?.map((sp, i) => {
                                return (
                                    <div key={"sp-" + i}>
                                        <div className={`pi-c-pd-sp-check ${sp?.selected ? "selected" : ""}`}>
                                            <FaCheck onClick={() => {
                                                updateSelectedPrograms(i);
                                            }} />
                                        </div>
                                        <h5 onClick={() => {
                                            updateSelectedPrograms(i);
                                        }}>{`${sp?.title?.toUpperCase()}${sp?.level ? (" - " + sp?.level?.toUpperCase()) : ""}`}</h5>
                                    </div>
                                );
                            })
                        }
                        <div className='pi-c-pd-sp-more'>
                            <h5 onClick={() => {
                                setShowAllPrograms(!showAllPrograms);
                            }}>{`${!showAllPrograms ? "Select new programs" : "Hide Programs"} >`}</h5>
                        </div>
                    </div>
                </div>

                <div id="pi-c-pd-email-preview" className={`flip-card ${isEdit ? 'flipped' : ''}`}>
                    <div id="action-btns">
                        {
                            isEdit
                                ? <>
                                    <CustomActionButton className="active" size="small" action={saveEditedEmail}>
                                        Save
                                    </CustomActionButton>
                                    <CustomActionButton type={2} isPrimary={false} size="small" action={revertEditedEmail}>
                                        Cancel
                                    </CustomActionButton>
                                </>
                                : <CustomButton isPrimary={false} size="small" onClick={arrangeEditEmail}>
                                    Edit Email
                                </CustomButton>
                        }

                    </div>
                    {
                        isEdit
                            ? <div className="editable" dangerouslySetInnerHTML={{ __html: emailTemplate?.html_content }} />
                            : <div className="preview" dangerouslySetInnerHTML={{ __html: htmlPreview }} />
                    }


                    {/* <div id="pi-c-pd-email-preview-edit">
                        <pre>{htmlPreview}</pre>
                    </div> */}
                </div>


            </div>


        </div >
    );
}


const mapStateToProps = (state) => ({
    User: state.User,
});

export default connect(mapStateToProps, {
    AddNewCustomEmailTemplate,
    SetModalProperties,
    SaveEmailTemplate,
    SendEmail,
})(PatientDetailV2);
